import { Stack, StackProps } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { FC } from 'react';

export const SuccessBlock: FC<StackProps> = ({ children, sx, ...props }) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={(theme) => ({
        border: theme.mixins.borderValue(),
        borderColor: theme.palette.success.main,
        borderRadius: theme.spacing(1),
        bgcolor: theme.palette.success.superLight,
        color: theme.palette.success.main,
        p: 1.5,
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...props}
    >
      {children}
    </Stack>
  );
};
